/**
 * Validation result + error types for the Voluum payload validator.
 * For Media Devoted | Created By Ciro Autiero
 */

/** Field path inside the flow JSON, e.g. `conditionalPathsGroups[0].paths[1].name`. */
export type ValidationFieldPath = string;

/** Reason codes — make tests assert exactly what failed. */
export type ValidationErrorCode =
  | 'missing_required'
  | 'wrong_type'
  | 'invalid_enum'
  | 'invalid_array'
  | 'invalid_object'
  | 'empty_required_array'
  | 'invalid_value'
  | 'improper_automation';

export interface ValidationError {
  path: ValidationFieldPath;
  code: ValidationErrorCode;
  message: string;
  /** Optional context — what we received vs what we expected. */
  expected?: string;
  received?: string;
}

export type ValidationResult<T> =
  | { ok: true; value: T }
  | { ok: false; errors: ValidationError[] };

/**
 * Thrown by `validateFlowUpdateOrThrow` and surfaces structured errors at
 * the apply boundary (FE service / BE controller).
 */
export class VoluumPayloadValidationError extends Error {
  readonly errors: ValidationError[];

  constructor(errors: ValidationError[]) {
    const summary = errors
      .slice(0, 3)
      .map((e) => `${e.path}: ${e.message}`)
      .join('; ');
    const suffix = errors.length > 3 ? ` (+${errors.length - 3} more)` : '';
    super(`Voluum payload validation failed: ${summary}${suffix}`);
    this.name = 'VoluumPayloadValidationError';
    this.errors = errors;
  }
}
